import { useShallowEqualSelector } from "@/app/_helpers/redux";

import { useAppPermissions } from "../../hooks/use-app-permissions";
import { ConsentSurveyMenuItem } from "./components/1-consent-survey-main-navigation-menu-item";
import { MyMatchTagsMenuItem } from "./components/4-my-match-tags-menu-item";
import { PrivacyAndLogoutMenuItems } from "./components/6-privacy-and-logout-menu-items";

interface BottomMainNavigationMenuItemsProps {
  isCollapsed: boolean;
}

export function BottomMainNavigationMenuItems({
  isCollapsed,
}: BottomMainNavigationMenuItemsProps) {
  const { hasConsentSurveyPermissions, currentUserClinician } =
    useAppPermissions();

  const [currentUser] = useShallowEqualSelector((state) => [
    state.auth.currentUser,
    state.options.doMangle,
  ]);

  return (
    <>
      {hasConsentSurveyPermissions ? (
        <li>
          <ConsentSurveyMenuItem isCollapsed={isCollapsed} />
        </li>
      ) : null}

      {currentUserClinician ? (
        <li>
          <MyMatchTagsMenuItem isCollapsed={isCollapsed} />
        </li>
      ) : null}

      {currentUser ? (
        <PrivacyAndLogoutMenuItems isCollapsed={isCollapsed} />
      ) : null}
    </>
  );
}
